import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import config from "@/common/config";
import apiCore from "@/api/api.common";
import store from "@/store";
import localStore from '@/store/localStore';
import { Cache, cacheAdapterEnhancer, throttleAdapterEnhancer } from 'axios-extensions';

const ApiService = {
    init() {
      
      const instance = axios.create({
        baseURL: config.api.uri,
        timeout: 30000,
        headers: { 'Cache-Control': 'no-cache' },
        // cache will be enabled by default
        adapter: cacheAdapterEnhancer(axios.defaults.adapter, { enabledByDefault: false, cacheFlag: 'useCache' })
      });
      
      Vue.use(VueAxios, instance);
      Vue.axios.defaults.headers.post["Content-Type"] = "application/json";
  
      // Add a request interceptor
      Vue.axios.interceptors.request.use(
        config => {
          let token = localStore.getItem('token');

          if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
          }
          return config;
        },
        error => {
          return Promise.reject(error);
        }
      );
  
      

  },
    
  
    apiCore,
    isTokenExpired(error) {
      // logic to determine if the error is due to JWT token expired returns a boolean value
      if (error && error.response && error.response.status == 401) {
        let expiresTime = store.state.account.auth.expiresAt; // capture the expire date from last authentication
        const hasTimeRemaining = util.isFutureDate(expiresTime); 
        return !hasTimeRemaining;// if that date is still in the future, we should still be ok.
      } else {
        return false; // default, something else has has triggered error, let axios handle as needed.
      }
    }
  };
  
  export default ApiService;